import React, { useState, useEffect, useRef } from "react";
import "../styles/sirappu.css";

const ImageSlider = ({ images }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  const intervalRef = useRef(null);

  const nextSlide = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const startInterval = () => {
    intervalRef.current = setInterval(() => {
      setCurrentImageIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 3000);
  };

  const clearCurrentInterval = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
  };

  useEffect(() => {
    startInterval();
    return () => clearCurrentInterval();
  }, [images.length]);

  const handleMouseEnter = () => {
    setIsHovered(true);
    clearCurrentInterval();
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    startInterval();
  };

  return (
    <div
      className="slider-containersira"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {images.map((image, index) => (
        <div
          key={index}
          className={`slidesira ${index === currentImageIndex ? "active" : ""}`}
          style={{ backgroundImage: `url(${image})` }}
        />
      ))}
      <button className="slider-buttonsira prev" onClick={prevSlide}>
        &#10094;
      </button>
      <button className="slider-buttonsira next" onClick={nextSlide}>
        &#10095;
      </button>
      <div className="slide-indicators">
        {images.map((_, index) => (
          <span
            key={index}
            className={`indicator ${
              index === currentImageIndex ? "active" : ""
            }`}
            onClick={() => setCurrentImageIndex(index)}
          />
        ))}
      </div>
      {/* {isHovered && (
        <div className="pause-overlay">
          <div className="pause-icon">⏸</div>
        </div>
      )} */}
    </div>
  );
};

const TabContent = ({ tab }) => {
  const [tabDatautp, settabDatautp] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("/data/tabDatautp.json");
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        console.log(data);

        settabDatautp(data.tabDatautp);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) return <div className="loading-message">Loading...</div>;
  if (error) return <div className="error-message">Error: {error}</div>;

  const currentTabData = tabDatautp[tab];

  return (
    <div className="tab-contentsira">
      <div className="content-wrapper">
        <h2 className="tab-title">{currentTabData.head}</h2>
        <ImageSlider images={currentTabData.images} />
        <h2 className="tab-title">{currentTabData.title}</h2>
        <div className="description-container">
          <p className="description-text">{currentTabData.description}</p>
          {currentTabData.description1 && (
            <p className="description-text">{currentTabData.description1}</p>
          )}
        </div>
      </div>
    </div>
  );
};

const Utp = () => {
  const [activeTab, setActiveTab] = useState("tab1");

  return (
    <div className="appsira">
      <h1 className="page-title">உலகத் தமிழர் படைப்பரங்கம்</h1>
      <div className="tabssira">
        <button
          className={`tab-buttonsira ${activeTab === "tab1" ? "active" : ""}`}
          onClick={() => setActiveTab("tab1")}
        >
          உலகத் தமிழர் படைப்பரங்கம்
        </button>
        <button
          className={`tab-buttonsira ${activeTab === "tab2" ? "active" : ""}`}
          onClick={() => setActiveTab("tab2")}
        >
          2008
        </button>
        <button
          className={`tab-buttonsira ${activeTab === "tab3" ? "active" : ""}`}
          onClick={() => setActiveTab("tab3")}
        >
          2014
        </button>
        <button
          className={`tab-buttonsira ${activeTab === "tab4" ? "active" : ""}`}
          onClick={() => setActiveTab("tab4")}
        >
          2015
        </button>
        <button
          className={`tab-buttonsira ${activeTab === "tab5" ? "active" : ""}`}
          onClick={() => setActiveTab("tab5")}
        >
          2016
        </button>
        <button
          className={`tab-buttonsira ${activeTab === "tab6" ? "active" : ""}`}
          onClick={() => setActiveTab("tab6")}
        >
          2017
        </button>
        <button
          className={`tab-buttonsira ${activeTab === "tab7" ? "active" : ""}`}
          onClick={() => setActiveTab("tab7")}
        >
          மறைந்த உலகப்படைப்பாளிகளின் படங்கள்
        </button>
      </div>

      <TabContent tab={activeTab} />
    </div>
  );
};

export default Utp;
